var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("register-credential-tef", { ref: "RegisterCredentialTef" }),
      _c("show-credential-tef", { ref: "ShowCredentialsTef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }